import React, {useContext, useEffect, useState} from 'react';
import {Modal, Spinner} from 'react-bootstrap';
import {observer} from 'mobx-react-lite';
import {Context} from '../../index';
import PostImagesContainer from '../PostImagesContainer/PostImagesContainer';
import Button from '../ui/Button';
import styles from './ExamplesByCategoryModal.module.css';

const ExamplesByCategoryModal = observer(({category, show, onHide}) => {
    const {posts} = useContext(Context);
    const [isLoading, setIsLoading] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (!show || !category) return;

        setIsLoading(true);
        setCurrentIndex(0);
        posts.loadPostsByCategory(category).finally(() => setIsLoading(false));
    }, [show, category, posts]);

    const examples = posts.categoryPosts;
    const currentPost = examples[currentIndex];
    const canBrowse = examples.length > 1;

    const showPrevious = () => {
        setCurrentIndex((index) => (index === 0 ? examples.length - 1 : index - 1));
    };

    const showNext = () => {
        setCurrentIndex((index) => (index === examples.length - 1 ? 0 : index + 1));
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg" className={styles.modal}>
            <Modal.Header closeButton>
                <Modal.Title>{category}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? (
                    <div className={styles.state}>
                        <Spinner animation="grow"/>
                    </div>
                ) : currentPost ? (
                    <div className={styles.example}>
                        <PostImagesContainer post={currentPost}/>
                        <h2>{currentPost.header}</h2>
                        {canBrowse && (
                            <div className={styles.controls}>
                                <Button type="button" variant="secondary" onClick={showPrevious}>Назад</Button>
                                <span>{currentIndex + 1} / {examples.length}</span>
                                <Button type="button" variant="primary" onClick={showNext}>Вперёд</Button>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className={styles.state}>В этой категории пока нет примеров работ.</div>
                )}
            </Modal.Body>
        </Modal>
    );
});

export default ExamplesByCategoryModal;
